import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { PanelService } from '../../services/panel.service';
import { EventSocketService } from './../../../events/services/event-socket.service';

import { EventService } from 'src/app/events/services/event.service';
import { UserDataService } from 'src/app/profile-config/services/user-data.service';
import { TabService } from '../../services/tab.service';
import { MultimediaService } from 'src/app/multiview/services/multimedia.service';
import { SessionService } from 'src/app/logout/services/session.service'; // Importar SessionService
import { ConfigurationService } from 'src/app/shared/services/configuration.service';
import { PermissionService } from 'src/app/permiss/permission.service';

import { NavbarConfig } from 'src/app/shared/models/configuration';
declare var $: any;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, AfterViewInit {

  public config! : NavbarConfig;
  logo:string = "assets/images/logo-gl-tracker-blue-dark.svg";
  sidevarIZ:boolean=true;
  logOutModalDisplay: boolean = false;
  windowAccess = window;

  userName: string = '';
  userEmail: string = '';
  userDataInitialized: boolean = false;

  userData: any; //Informacion del usuario
  showBtnSubcuentas = false;
  showBtnDrivers =true;
  showMultiviewModal = false;
  showListReportsCollapsed = false;

  // configuracion de usuario
  public displayUserConfigDialog : boolean = false;
  public displayReportesCSV : boolean = false;

  public reportwithOptions : boolean = false;

  constructor(
    public eventService: EventService,
    public eventSocketService : EventSocketService,
    public panelService: PanelService,
    private userDataService: UserDataService,
    private tabService: TabService,
    private router: Router,
    private multimediaService: MultimediaService,
    private sessionService: SessionService,
    private permissionService : PermissionService,
    private configurationService : ConfigurationService
  ) {
    this.tabService.setCurrentTab('main-panel');
    this.initTabService();
  }
  
  ngAfterViewInit(): void {
    const permissionReports = [
      'reports_module_ScheduleReport',
      'reports_module_ExportCSV',
      'new_reports_module',
    ]

    if (!this.userDataService.userDataInitialized) {
      this.userDataService.userDataCompleted.subscribe((s)=>{
        Promise.all(permissionReports.map(p => this.permissionService.hasPermission(p)))
          .then(results => {
            console.log(results,"permisos de reportes")
            this.reportwithOptions = results.includes(true);
          });
      })
    } else {
      this.userDataService.userDataCompleted.subscribe((s)=>{
        Promise.all(permissionReports.map(p => this.permissionService.hasPermission(p)))
          .then(results => {
            console.log(results,"permisos de reportes")
            this.reportwithOptions = results.includes(true);
          });
      })
    }
  }

  private initTabService() {
    // console.log('tab init');
    if (localStorage.getItem('user_id') != null) {
      this.tabService.currentTabReady.subscribe({
        next: (response: boolean) => {
          if (response) {
            if (this.tabService.requiresVehicleServices()) {
              // this.vehicleService.initialize();
            }
            if (this.tabService.requiresEventServices()) {
              this.eventService.getAll();
              this.eventSocketService.listen();
            }
            if (this.tabService.requiresUserDataServices()) {
              // this.userDataService.getUserData();
            }
          }
        },
        error: (errorMsg: any) => {
          console.log(errorMsg);
        },
      });
    } else {
      console.log('error tab init');
    }

    this.eventSocketService.user_id = localStorage.getItem('user_id');
    this.eventSocketService.initializeSocket(this.eventSocketService.user_id);
    // this.vehicleService.setDefaultStatusDataVehicle();
    // this.vehicleService.initialize();
    this.eventService.getAll();
    this.eventSocketService.listen();
  }

  ngOnInit(): void {
    this.configurationService.navbarConfig$.subscribe(cfg => {
      this.config = cfg;
      console.log("load panel navbar configuracion pshow", this.config)
    });
    if(!this.userDataService.userDataInitialized){
      console.log('(Navbar) User Data no está listo. Subscribiendo para obtener data...');
      this.userDataService.userDataCompleted.subscribe({
        next: (result: boolean) => {
          if(result){
            this.getUserData();
          }
        },
        error: (errMsg: any) => {
          console.log('(Navbar) Error al obtener userData: ', errMsg);
        }
      });
    } else {
      console.log('(Navbar) User Data está listo. Subscribiendo para obtener data...');
      this.getUserData();
    }
    $('[data-bs-toggle="tooltip"]').click(function(){
      $('[data-bs-toggle="tooltip"]').tooltip('hide');
    });

    $('.dropdown-menu li').hover(() =>{
      $(".tooltip").css("display", "none");
    });
  }

  

  getUserData(){
    this.userName = this.userDataService.userData.nombre_usuario.normalize('NFKD').replace(/[^a-zA-ZñÑáéíóúÁÉÍÓÚäëïöüÄËÏÖÜ0-9 -_.@]+/g, '').replace(/  +/g, ' ').trim();
    this.userEmail = this.userDataService.userData.email;
    this.userDataInitialized = true;
    if(!this.isSubuser()){
      this.showBtnSubcuentas = true;
    }
  }

  isSubuser(){
    return this.userDataService.userData.privilegios == "subusuario";
  }

  showHideSideBar(): void {

    //console.log("Mostrar-Esconder sidebar");
    if(this.sidevarIZ){
      $("#panel_sidebar").hide( "slow" );
      $("#panelMonitoreo").hide( "slow" );

      this.sidevarIZ = false;
    } else {
      $("#panel_sidebar").show( "slow" );
      this.sidevarIZ = true;
    }

  }

  clickShowModalMultiview(){
    this.panelService.nombreComponente = "MULTIVIEW";
    $("#panelMonitoreo").hide( "slow" );
    this.showMultiviewModal = true;
  }
  onHideMultiviewModal(){
    this.panelService.nombreComponente = "";
    this.showMultiviewModal = false;
  }

  async logOut(): Promise<void> {

     // Registra la actividad de cierre de sesión en el panelService
     await this.panelService.activity_logout({ id: '477' });

     // Limpia el almacenamiento multimedia si es necesario
     await this.multimediaService.clearAllMultimediaStorage();
     this.sessionService.triggerSessionExpired(true);
     // Limpia todo el almacenamiento local
     localStorage.clear();

  };
  
  public openUserConfigDialog() {
    this.panelService.clickShowPanel(this.panelService.nombreComponente) // para desaparecer el panel actual
    this.displayUserConfigDialog = !this.displayUserConfigDialog;
  }

  openReportCsvDialog(event: Event) {
    event.preventDefault();  // esto evita que el enlace navegue
    this.panelService.clickShowPanel(this.panelService.nombreComponente) // para desaparecer el panel actual
    this.displayReportesCSV = !this.displayReportesCSV;
  // Aquí tu lógica para abrir el diálogo
}

  public handleDialogClose() {
    console.log("configuration : try save configuration")
    this.configurationService.saveConfiguractionServiceToStorage();
    this.configurationService.saveConfiguration();
  }
}
